import React from 'react';
import { Card, LargeTitle, TinyTitle, palettes, LegalBody } from '@indigo-ag/component-module';
import { utils } from 'shared';

export interface PhaseSectionProps {
  title: string;
  subtitle?: string;
  topRightContent?: React.ReactNode;
  updatedBy?: string;
  updatedAt?: Date;
  classes?: {
    card?: string;
    header?: string;
    content?: string;
    footer?: string;
  };
}

export const PhaseSection: React.FunctionComponent<PhaseSectionProps> = ({
  title,
  subtitle,
  topRightContent,
  children,
  updatedBy,
  updatedAt,
  classes
}) => {
  return (
    <Card className={`p-4 mt-3 ${classes?.card ? classes.card : ''}`}>
      <div className={`flex flex-space-btw align-items-center ${classes?.header ? classes.header : ''}`}>
        <div>
          <LargeTitle className="text-transform-capitalize">{title}</LargeTitle>
          {subtitle && (
            <TinyTitle
              className="text-transform-uppercase-first-letter mt-1"
              style={{ color: palettes.brand.gray[700] }}
            >
              {subtitle}
            </TinyTitle>
          )}
        </div>
        {topRightContent && <div>{topRightContent}</div>}
      </div>
      {children && <div className={`mt-4 ${classes?.content ? classes.content : ''}`}>{children}</div>}
      <div className={`flex flex-space-btw align-items-center ${classes?.footer ? classes.footer : ''}`}>
        {(updatedBy || updatedAt) && (
          <LegalBody className="mt-4">
            {updatedBy || null}
            {updatedBy && updatedAt ? ' - ' : null}
            {updatedAt ? utils.date.formatDate(updatedAt) : null}
          </LegalBody>
        )}
      </div>
    </Card>
  );
};
